import React from 'react';
import { ArrowUpRight, Sparkles } from 'lucide-react';
import './SkincareBanner.css';

export const SKINCARE_DEFAULTS = {
  enabled: true,
  homepageOnly: false,
  badge: 'COMING SOON',
  title: 'A new chapter in skincare.',
  text: 'Lindsey’s skincare line is on its way.',
  buttonText: 'Ask Lindsey',
  linkUrl: '/contact',
  newTab: false,
  imageUrl: '',
  backgroundColor: '#f5eef3',
  textColor: '#573d54',
  buttonColor: '#65405c',
  buttonTextColor: '#ffffff'
};

export function skincareLink(value) {
  const url = typeof value === 'string' ? value.trim() : '';
  return /^https?:\/\//i.test(url) || /^\/(?!\/)/.test(url) ? url : '';
}

function color(value, fallback) {
  return /^#[\da-f]{6}$/i.test(value || '') ? value : fallback;
}

export default function SkincareBanner({ settings, pathname = '/', preview = false }) {
  const config = { ...SKINCARE_DEFAULTS, ...settings };
  if (!preview && (!config.enabled || (config.homepageOnly && pathname !== '/'))) return null;
  const href = skincareLink(config.linkUrl);
  const image = config.imageUrl?.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL || ''}${config.imageUrl}` : config.imageUrl;
  return (
    <aside aria-label="Skincare announcement" className="skincare-banner" data-testid="skincare-banner" style={{ '--skincare-bg': color(config.backgroundColor, SKINCARE_DEFAULTS.backgroundColor), '--skincare-text': color(config.textColor, SKINCARE_DEFAULTS.textColor), '--skincare-button': color(config.buttonColor, SKINCARE_DEFAULTS.buttonColor), '--skincare-button-text': color(config.buttonTextColor, SKINCARE_DEFAULTS.buttonTextColor) }}>
      <div className="skincare-banner__inner">
        <div className="skincare-banner__message">
          {image ? <img className="skincare-banner__image" src={image} alt="" width="44" height="44" onError={e => { e.currentTarget.style.display = 'none'; }} /> : <span className="skincare-banner__icon"><Sparkles size={20} aria-hidden="true" /></span>}
          <div className="skincare-banner__copy">
            {config.badge && <span className="skincare-banner__badge">{config.badge}</span>}
            <span className="skincare-banner__title">{config.title}</span>
            {config.text && <span className="skincare-banner__text">{config.text}</span>}
          </div>
        </div>
        {href && config.buttonText && <a className="skincare-banner__button" href={href} {...(config.newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}><span>{config.buttonText}</span><ArrowUpRight size={16} aria-hidden="true" />{config.newTab && <span className="sr-only"> (opens in a new tab)</span>}</a>}
      </div>
    </aside>
  );
}
